import * as actions from './actionTypes';

export const setLoading = loading => ({
  type: actions.SET_LOADING,
  loading,
});

export const setMessage = message => {
  if (message === 'Erro de validação description must be unique') {
    message = 'Erro: A descrição deve ser única'
  }

  return ({
    type: actions.SET_MESSAGE,
    message,
  })
};

export const clearMessage = () => ({
  type: actions.CLEAR_MESSAGE,
});
